import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import { Icons } from '../../../shared/helpers/icons';
import { LockdownMessage, MESSAGE_TYPE_LABELS } from '../../../shared/models/message.model';

@Component({
  selector: 'app-message-details-modal',
  standalone: true,
  imports: [CommonModule, LucideAngularModule],
  templateUrl: './message-details-modal.component.html',
  styleUrl: './message-details-modal.component.css'
})
export class MessageDetailsModalComponent {
  @Input() message: LockdownMessage | null = null;
  @Output() closed = new EventEmitter<void>();

  icons = Icons;
  readonly noContentHtml = '<p class="text-gray-400 italic">(No content)</p>';

  messageTypeLabel(type: number): string {
    return MESSAGE_TYPE_LABELS[type] ?? 'Unknown';
  }
}
